import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntPositions } from "../../../../models/handBooks/positions";
import SelectDepartment from "../../../../components/selects/SelectDepartment";
import SelectGovernment from "../../../../components/selects/SelectGovernment";
import SelectPositions from "../../../../components/selects/SelectPositions";

enum FormField {
    nameKy,
    nameRu,
    parentId,
    departmentId,
    governmentId
}
interface IProps {
    show: boolean;
    position: EntPositions;
    onHide: () => void;
    onSubmit: (pos: EntPositions) => Promise<boolean>;
}

export const AddPositionModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedGovernment, setSelectedGovernment] = useState<number | null>(null);
    const [selectedDepartment, setSelectedDepartment] = useState<number | null>(null);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.nameKy, value: props.position.nameKy },
            { name: FormField.nameRu, value: props.position.nameRu },
            { name: FormField.departmentId, value: props.position.department?.id },
            { name: FormField.governmentId, value: props.position.department?.government?.id },
            { name: FormField.parentId, value: props.position.parentId },
        ]);
    }

    const setEntityFromFields = (): EntPositions => {
        let position = _.cloneDeep(props.position);
        position.nameKy = form.getFieldValue(FormField.nameKy);
        position.nameRu = form.getFieldValue(FormField.nameRu);
        position.departmentId = form.getFieldValue(FormField.departmentId);
        position.parentId = form.getFieldValue(FormField.parentId);
        return position;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }
  
    return (
        <>
            <DraggableModal
                title={props.position.id === 0 ? t('handbooks.positions.add_position') : t('handbooks.positions.edit_position')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >

                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                    >
                        <Input autoComplete="off" />
                    </Form.Item>

                    <Form.Item
                        label={t('Организация')}
                        name={FormField.governmentId}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <SelectGovernment
                            value={selectedGovernment}
                            onChange={(id) => {
                                setSelectedGovernment(id);
                                form.setFields([{ name: FormField.departmentId, value: null },{ name: FormField.parentId, value: null }])
                            }}
                        />
                    </Form.Item>
                    {
                        props.position.government !== null || selectedGovernment !== null ?
                            <Form.Item
                                label={t('Отдел')}
                                name={FormField.departmentId}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <SelectDepartment
                                    onChange={(id) => {
                                        setSelectedDepartment(id);
                                        form.setFields([{ name: FormField.parentId, value: null }])
                                    }}
                                    governmentIds={selectedGovernment !== null ? [selectedGovernment] : null}
                                />
                            </Form.Item>
                            : ""
                    }
                    {
                        props.position.government !== null || selectedGovernment !== null ?
                            <Form.Item
                                label={t('Родительская должность')}
                                name={FormField.parentId}
                            >
                                <SelectPositions
                                    departmentIds={selectedDepartment !== null ? [selectedDepartment] : null}
                                />
                            </Form.Item>
                            : ""
                    }
                </Form>
            </DraggableModal>
        </>
    )
}